/**
 * Some top-level header menu items (e.g. "Water Filter System", "Water Dispenser")
 * exist only to reveal their mega menu / dropdown on hover or focus — they are not
 * meant to navigate anywhere on click. This script stops the default navigation for
 * any menu link marked with [data-menu-no-navigate], without affecting the existing
 * hover/focus activation logic already handled by header-menu.js.
 *
 * Uses event delegation on document so it keeps working even if the menu markup is
 * re-rendered (e.g. via the Section Rendering API).
 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-no-navigate]');
  if (trigger) {
    event.preventDefault();
  }
});
